export default {
  confirm: '確認',
  cancel: '取消',
  save: '儲存',
  noSave: '不儲存',
  delete: '刪除',
  edit: '編輯',
  add: '新增',
  search: '搜尋',
  reset: '重置',
  back: '返回',
  submit: '提交',
  loading: '載入中...',
  noData: '暫無資料',
  noMoreData: '沒有資料了',
  success: '操作成功',
  failed: '操作失敗',
  required: '此項為必填',
  development: '開發中',
  underConstruction: '功能建設中',
  all: '全部',
  operation: '操作',
  pleaseInputLanguage: '請輸入語言',
  pleaseSelect: '請選擇',
  pleaseInput: '請輸入',
  upload: '上傳',
  uploadVideo: '上傳影片',
  uploadImage: '上傳圖片',
  previousStep: '上一步',
  nextStep: '下一步',
  sort: '排序',
  multilingual: '多語言',
  languageVersion: '語言版本',
  select: '選擇',
  total: '共',
  item: '條',
  updatedAt: '更新時間',
  current: '目前',
  switch: '切換',
  copy: '複製',
  pleaseEnter: '請輸入',
  comingSoon: '功能開發中',
  home: '首頁',
  action: '操作',
  warning: '警告',
  logout: '退出登入',
  logoutConfirm: '確認退出',
  logoutConfirmContent: '確定要退出登入嗎？',
  user: '使用者',
  adminTitle: '後台管理',
  selectField: '選擇欄位',
  none: '無',
  copySuccess: '複製成功',
};
